/** Assistant links stay on approved Danaro surfaces. */
export function allowedLink(value: string | undefined) {
  if (!value) return null
  if (value.startsWith("/") && !value.startsWith("//") && !value.includes("\\")) return value
  try {
    const url = new URL(value)
    if (!["https:", "http:"].includes(url.protocol) || url.username || url.password) return null
    const publicHost = ["danarolimo.com", "www.danarolimo.com", "crm.danarolimo.com", "my.danarolimo.com"].includes(url.hostname) && url.protocol === "https:" && (!url.port || url.port === "443")
    const localHost = ["localhost", "127.0.0.1", "crm.danaro.localhost", "my.danaro.localhost"].includes(url.hostname) && ["4180", "4181"].includes(url.port)
    return publicHost || localHost ? url.toString() : null
  } catch { return null }
}
